import React, { useState, useEffect, useRef } from "react";
import "../Styles/Contect.css"; // Fixed file name typo in CSS
import "../Styles/Home.css";
import ReCAPTCHA from "react-google-recaptcha";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config/Config";
import { Helmet } from "react-helmet";
import ListingHero from "./ListingHero";
import { MdEmail } from "react-icons/md";
import { BsLinkedin } from "react-icons/bs";
import { FaFacebook } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
export default function Contact() {
  const [configuration, setConfiguration] = useState([]);
  const [data, setData] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
    comment: "",
  });
  const [recaptcha, setRecaptcha] = useState("");
  const captchaRef = useRef(null);
  const [errors, setErrors] = useState({});

  // Fetch site configuration
  useEffect(() => {
    const fetchConfiguration = async () => {
      try {
        const response = await fetch(`${config.API_BLOG}configuration`);
        const data = await response.json();
        setConfiguration(data);
      } catch (err) {
        console.error("Error fetching configuration:", err);
      }
    };
    fetchConfiguration();
  }, []);

  // Validate form fields
  const validateForm = (data) => {
    const validationErrors = {};

    if (!data.name) validationErrors.name = "Name is required.";
    if (!data.email) {
      validationErrors.email = "Email is required.";
    } else if (!isValidEmail(data.email)) {
      validationErrors.email = "Please enter a valid email address.";
    }
    if (!data.number) {
      validationErrors.number = "Phone number is required.";
    } else if (!isValidNumber(data.number)) {
      validationErrors.number = "Please enter a valid 10-digit phone number.";
    }
    if (!data.comment) validationErrors.comment = "Comment is required.";
    if (!recaptcha)
      validationErrors.recaptcha = "Please complete the reCAPTCHA.";

    return validationErrors;
  };

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isValidNumber = (number) => /^[0-9]{10}$/.test(number);

  // Handle form input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value.trim(),
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        const response = await fetch(`${config.API_BLOG}contact`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
        const result = await response.json();
        toast.success(result.message || "Comment submitted successfully!");
        setFormData({ name: "", email: "", number: "", comment: "" });
        captchaRef.current.reset();
        setRecaptcha("");
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("An error occurred. Please try again later.");
      }
    }
  };

  // Handle reCAPTCHA change
  const onRecaptchaChange = (value) => {
    setRecaptcha(value);
  };

  const SITE_KEY = "6LeyK60sAAAAAJMCWH9XvK_0hutp8kGNUbHhytDL";

  // const secret_key ="6LeyK60sAAAAANuiS3JDarcZTFhL-1t7h2AO3C-9"

  const metaTitle = configuration[0]?.default_meta_title || "Contact Us";
  const metaKeywords =
    configuration[0]?.default_meta_keywords || "contact, feedback";
  const metaDescription =
    configuration[0]?.default_meta_description || "Get in touch with us.";
  const siteLabel =
    configuration[0]?.default_meta_title?.split("|")[0]?.trim() || "iLearnings";
  const contactEmail = configuration[0]?.contact_email;

  function fetchConfiguration() {
    fetch(`${config.API_BLOG}configuration`)
      .then((result) => result.json())
      .then((res) => {
        setData(res);
      })
      .catch((err) => console.error("Error fetching configuration:", err));
  }

  useEffect(() => {
    fetchConfiguration();
  }, []);

  const linkedinLink = data[0]?.linkdin_page_link;
  const Email = data[0]?.contact_email;
  const Facebook = data[0]?.facebook_page_link;
  const Instagram = data[0]?.instagram_page_link;

  return (
    <div className="home-page page-shell py-4 mb-5">
      {/* Helmet for SEO */}
      <Helmet>
        <title>contact</title>
        <meta name="title" content={metaTitle} />
        <meta name="keywords" content={metaKeywords} />
        <meta name="description" content={metaDescription} />
      </Helmet>

      <ListingHero
        siteLabel={""}
        badge="Get in touch"
        headlinePrefix=""
        description="Send us your questions, feedback, or ideas. We’ll get back to you as soon as possible."
        primaryCtaTo="/blog"
        primaryCtaLabel=""
        secondaryCtaTo="/tutorialseries"
        secondaryCtaLabel=""
        primaryStat={""}
        primaryStatLabel=""
        secondaryStat={""}
        secondaryStatLabel=""
      />

      {/* Contact Form + Info */}
      <div className="row justify-content-center con g-4 mt-2">
        <div className="col-12 col-lg-4" data-aos="fade-up">
          <div className="contact-card box">
            <p className="box1">Quick Contact</p>
            <div className="p-4">
              <div className="mt-3">
                <div className="contact-info-row">
                  <span className="contact-info-pill">Email</span>
                  <span className="contact-info-value">
                    {contactEmail || "info@ilearnings.in"}
                  </span>
                </div>
              </div>
              <div className="mt-3">
                <div className="contact-info-row">
                  <span className="contact-info-pill">Follow</span>
                  <span className="contact-info-value">
                    <div className="d-flex flex-wrap justify-content-center justify-content-md-end gap-2">
                      {Email ? (
                        <a
                          href={`https://mail.google.com/mail/?view=cm&fs=1&to=${Email}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <MdEmail className="icne" />
                        </a>
                      ) : null}

                      {linkedinLink ? (
                        <a
                          href={linkedinLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <BsLinkedin className="icne" />
                        </a>
                      ) : null}

                      {Facebook ? (
                        <a
                          href={Facebook}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaFacebook className="icne" />
                        </a>
                      ) : null}

                      {Instagram ? (
                        <a
                          href={Instagram}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaInstagramSquare className="icne" />
                        </a>
                      ) : null}
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="col-12 col-lg-8 col-xl-6"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <div className="contact-card box">
            <p className="box1">CONTACT US</p>
            <form className="px-3 px-md-4 pb-4 pt-2" onSubmit={handleSubmit}>
              <div>
                <input
                  type="text"
                  placeholder="Name"
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && (
                  <div className="invalid-feedback">{errors.name}</div>
                )}
              </div>
              <br />
              <div>
                <input
                  type="email"
                  placeholder="Email"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>
              <br />
              <div>
                <input
                  type="text"
                  placeholder="Phone Number"
                  className={`form-control ${errors.number ? "is-invalid" : ""}`}
                  name="number"
                  value={formData.number}
                  onChange={handleChange}
                />
                {errors.number && (
                  <div className="invalid-feedback">{errors.number}</div>
                )}
              </div>
              <br />
              <div>
                <textarea
                  placeholder="Comment"
                  className={`form-control ${errors.comment ? "is-invalid" : ""}`}
                  name="comment"
                  value={formData.comment}
                  onChange={handleChange}
                />
                {errors.comment && (
                  <div className="invalid-feedback">{errors.comment}</div>
                )}
              </div>
              <br />
              <div>
                <ReCAPTCHA
                  sitekey={SITE_KEY}
                  onChange={onRecaptchaChange}
                  ref={captchaRef}
                />
                {errors.recaptcha && (
                  <div className="invalid-feedback">{errors.recaptcha}</div>
                )}
              </div>
              <br />
              <div className="text-center">
                <button type="submit" className="btn btn-dark px-5 mb-4">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
